import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import './BusinessHour.css'
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import CheckBoxInputField from '../../infra/components/formInput/CustomCheckBoxInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import ActionGet from '../../store/action/BusinessHour/Fetch'
import ActionDelete from '../../store/action/BusinessHour/Delete'
import ActionEdit from '../../store/action/BusinessHour/Edit'
import ActionAdd from '../../store/action/BusinessHour/Add'
import ActionGetClient from '../../store/action/Client/FetchAll'
import { ClientId } from '../../helper/HelperAuth'

class Page extends Component {
  constructor(props) {
    super(props)
    this.state = {
      form: fromJS({
        "days": [
          {
            "dayofweek": 1,
            "dayname": "Sunday",
            "isworkingday": "false"
          },
          {
            "dayofweek": 2,
            "dayname": "Monday",
            "isworkingday": false
          },
          {
            "dayofweek": 3,
            "dayname": "Tuesday",
            "isworkingday": false
          },
          {
            "dayofweek": 4,
            "dayname": "Wednesday",
            "isworkingday": false
          },
          {
            "dayofweek": 5,
            "dayname": "Thursday",
            "isworkingday": false
          },
          {
            "dayofweek": 6,
            "dayname": "Friday",
            "isworkingday": false
          },
          {
            "dayofweek": 7,
            "dayname": "Saturday",
            "isworkingday": false
          }
        ],
        "hours-start": "",
        "hours-end": "",
        "auto-reply": "",
        "client-id": ''
      }),
      datatime: new Date().getTime(),
      errors: fromJS({})
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDays = this.handleChangeDays.bind(this);
    this.refreshData = this.refreshData.bind(this)
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.size > 0) {
      if (props.datatime !== state.datatime) {
        var days = fromJS([])
        var ids = fromJS([])
        var hoursend = ""
        var hourstart = ""
        // eslint-disable-next-line array-callback-return
        props.data.get('days').map((item) => {
          if (!ids.includes(item.get('dayofweek'))) {
            days = days.push(fromJS({
              "dayofweek": item.get('dayofweek'),
              "dayname": item.get('dayname'),
              "isworkingday": item.get('isworkingday')
            }))

            ids = ids.push(item.get('dayofweek'))
          }
        })

        if(props.data.get('hours-end') == "23:59:59"){
          hoursend = "00:00"
        }else{
          hoursend = props.data.get('hours-end') 
          let hourarr = hoursend.split(":")
          hoursend = hourarr[0]+":"+hourarr[1]
        }

        if(props.data.get('hours-start') == "00:00:01"){
          hourstart = "00:00"
        }else{
          hourstart = props.data.get('hours-start') 
          let hourarr = hourstart.split(":")
          hourstart = hourarr[0]+":"+hourarr[1]
        }
        //debugger
        return {
          form: fromJS({
            "days": days,
            "hours-start": hourstart,
            "hours-end": hoursend,
            "auto-reply": props.data.get('auto-reply'),
            "client-id": props.data.get('client-id')
          }),
          datatime: props.datatime,
        }
      }
    }
  }

  componentDidMount() {
    this.props.actionGetClient()
  }

  handleChange(field, value) {
    var formVal = this.state.form;

    if (field === 'client-id') {
      this.refreshData(value)
    }
    else {
      formVal = formVal.set(field, value);
      this.setState({ form: formVal })
    }
  }

  handleChangeDays(field, value) {
    var forms = this.state.form;
    var days = forms.get('days');

    days = days.map((x) => {
      if (x.get('dayofweek') === field) {
        return x.set('isworkingday', value);
      }
      return x
    })

    forms = forms.set('days', days);
    this.setState({ form: forms })
  }

  async handleSubmit(dispatch) {
    const { form } = this.state;
    const { data } = this.props;
    var formval = form
    if(formval.get("hours-end") == "00:00")
    {
      formval = formval.set("hours-end","23:59:59")
    }else{
      formval = formval.set("hours-end",formval.get("hours-end")+":01")
    }

    if(formval.get("hours-start") == "00:00")
    {
      formval = formval.set("hours-start","00:00:01")
    }else{
      formval = formval.set("hours-start",formval.get("hours-start")+":01")
    }
    //debugger
    var param = {
      'data': formval
    }
    var response = '';
    if (data.size === 0) {
      response = await this.props.actionAdd(param);
    } else {
      response = await this.props.actionEdit(param);
    }

    if (response !== '') {
      if (response.ok) {
        this.refreshData(form.get('client-id'))
        toast.success("Submit Success!", toast.POSITION.TOP_RIGHT)
      } else {
        toast.error("Submit Failed!", toast.POSITION.TOP_RIGHT)
      }
    }
  }

  refreshData(clientid) {
    const form = this.state
    if (clientid === undefined) {
      clientid = form.get('client-id')
    }

    var paramBody = {
      "data": {
        "client-id": clientid
      }
    };
    this.props.actionGet(paramBody);

    this.setState({
      form: fromJS({
        "days": [
          {
            "dayofweek": 1,
            "dayname": "Sunday",
            "isworkingday": "false"
          },
          {
            "dayofweek": 2,
            "dayname": "Monday",
            "isworkingday": false
          },
          {
            "dayofweek": 3,
            "dayname": "Tuesday",
            "isworkingday": false
          },
          {
            "dayofweek": 4,
            "dayname": "Wednesday",
            "isworkingday": false
          },
          {
            "dayofweek": 5,
            "dayname": "Thursday",
            "isworkingday": false
          },
          {
            "dayofweek": 6,
            "dayname": "Friday",
            "isworkingday": false
          },
          {
            "dayofweek": 7,
            "dayname": "Saturday",
            "isworkingday": false
          }
        ],
        "hours-start": "",
        "hours-end": "",
        "auto-reply": "",
        "client-id": clientid
      })
    })
  }

  render() {
    const { form } = this.state

    return (
      <div className="card">
        <div className="body">
          <div className="row">
            <div className="col-sm-12">
              <div className="input-group-btn">
                <ComboboxInput
                  field='client-id'
                  value={form.get('client-id')}
                  options={fromJS({
                    'source': this.props.clientall,
                    'value': 'client-id',
                    'label': 'client-name'
                  })}
                  onChange={(field, value, label) => this.handleChange(field, value, label)}
                  placeholder="Client"
                  disabled={this.state.disabled}
                />
              </div>

            </div>
          </div>

          <div className="row">

              <div className="col-sm-12 col-md-2">
                <label>Start Time</label>
                <DatePickerInput
                  className="business-hour-time"
                  type="Time"
                  convertvalue
                  field="hours-start"
                  value={form.get('hours-start')}
                  dateFormat="HH:mm"
                  onChange={(field, date) => this.handleChange(field, date)}
                  placeholder='Start time'
                />
              </div>

              <div className="col-sm-12 col-md-2">
              <label>End Time</label>
                <DatePickerInput
                  className="business-hour-time"
                  type="Time"
                  convertvalue
                  field="hours-end"
                  value={form.get('hours-end')}
                  dateFormat="HH:mm"
                  placeholder='End time'
                  onChange={(field, date) => this.handleChange(field, date)}
                />
              </div>
              <div style={{paddingTop: 20 + 'px'}} className="col-sm-12 col-md-8">

                {
                  form.get('days').map((item) => {
                    return (
                        <CheckBoxInputField className="form-control"
                          field={item.get('dayofweek')}
                          label={item.get('dayname')}
                          checked={item.get('isworkingday')}
                          onChange={(field, value) => this.handleChangeDays(field, value)}
                        />
                    )
                  })
                }
              </div>

          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="input-group-btn">
                <TextInputField className="form-control"
                  textarea
                  field={'auto-reply'}
                  value={form.get('auto-reply')}
                  onChange={(field, value) => this.handleChange(field, value)}
                  placeholder="message"
                />
              </div>

            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="input-group-btn">
                <button type="button"
                  className="btn btn-wide btn-success"
                  onClick={this.handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



export default connect(
  (state) => {
    return {
      data: state.user.businesshour,
      datatime: state.user.businesshourtime,
      clientall: state.user.clientall
    }
  },
  dispatch => bindActionCreators({
    actionGet: ActionGet,
    actionDelete: ActionDelete,
    actionEdit: ActionEdit,
    actionAdd: ActionAdd,
    actionGetClient: ActionGetClient,
  }, dispatch),
)(Page);